import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconWehagoUploadLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M9.458 11.146v2.801c0 .154.052.282.155.385.102.104.23.155.382.155a.533.533 0 0 0 .546-.54v-2.8l1.014 1.012c.052.052.113.09.184.114a.613.613 0 0 0 .41.008.452.452 0 0 0 .186-.107.511.511 0 0 0 .177-.388.546.546 0 0 0-.175-.384L10.466 9.53a.582.582 0 0 0-.207-.149.693.693 0 0 0-.258-.043c-.1 0-.187.014-.259.043a.582.582 0 0 0-.206.15l-1.873 1.872a.507.507 0 0 0-.16.374c0 .14.06.266.176.377.115.12.244.18.387.177a.541.541 0 0 0 .381-.172l1.012-1.012ZM5.75 17.584c-.375 0-.691-.13-.948-.389a1.299 1.299 0 0 1-.385-.951V3.757c0-.375.129-.692.388-.951.26-.26.576-.389.951-.389h5.891a1.315 1.315 0 0 1 .958.397l2.58 2.58a1.315 1.315 0 0 1 .398.959v9.89c0 .376-.13.693-.389.952a1.29 1.29 0 0 1-.952.389H5.75Zm5.666-11.67V3.5h-5.66a.245.245 0 0 0-.176.08.245.245 0 0 0-.08.177v12.487c0 .064.027.123.08.176.053.054.112.08.176.08h8.487a.244.244 0 0 0 .177-.08.244.244 0 0 0 .08-.176v-9.66h-2.414a.649.649 0 0 1-.478-.192.649.649 0 0 1-.192-.478Z"
      />
    </Svg>
  );
};

export default IconWehagoUploadLine;
